<template>
  <div class="h-full sm:min-h-screen w-full flex flex-col items-center">
    <div class="flex w-full">
      <div class="hidden lg:block lg:w-1/2 max-w-6xl">
        <GuestBanner />
      </div>
      <div class="flex flex-col justify-center px-8 mx-auto lg:mx-8 max-w-xl w-full">
        <div class="lg:my-10">
          <GuestHeading :title="title" />
          <router-view :key="$route.path"></router-view>
        </div>
        <GuestFooter />
      </div>
    </div>
    <GuestPrivacyCookie />
  </div>
</template>

<script>
import {
  GuestBanner,
  GuestHeading,
  GuestFooter,
  GuestPrivacyCookie,
} from '@/components/layouts/partials'

export default {
  computed: {
    title() {
      return this.$store.getters['app/pageTitle']
    },
  },
  components: {
    GuestBanner,
    GuestHeading,
    GuestFooter,
    GuestPrivacyCookie,
  },
}
</script>
